<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #roleInput
          formControlName="role" 
          [matAutocomplete]="roleAC" 
          [placeholder]="'LABEL_ROLE' | translate"
          (focus)="!roleAC.isOpen && getInitialValues('role')" 
          (blur)="checkAutocompleteObject(form, 'role')"
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_role_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="clearForm($event)"
          *ngIf="roleInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!roleInput.value && !disabled"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_role_dropdown"
          [displayWith]="displayFn" 
          #roleAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); roleInput.blur()"
          (opened)="autocompleteScroll('role','roleACRef','roleACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.role && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_role_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.code + ' - ' + data.description"
            >
            {{ data.code != 'all' ? (data.code + ' - ') : '' }} {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.role" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('role').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('role').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_ROLE' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>